import { createUseStyles } from 'react-jss'
import { DARK_GRAY_80, WHITE } from '@omnilert/components'

export default createUseStyles({
  buttons: {
    width: '30%',
    display: 'flex',
    justifyContent: 'flex-end',
    '& button:first-child': {
      marginRight: '5px'
    }
  },
  header: {
    padding: '24px 0'
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px ,solid rgba(8, 13, 20, 0.05)',
    padding: '24px 0'
  },
  detailsText: {
    width: '70%'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: WHITE
  },
  content: {
    backgroundColor: WHITE,
    height: '100%',
    overflowY: 'auto',
    padding: '0 24px 24px 24px',
    width: '100%'
  },
  messageDetails: {
    color: DARK_GRAY_80,
    fontFamily: 'BentonSansMedium',
    fontSize: '12px',
    lineHeight: '24px'
  },
  messageText: {
    color: DARK_GRAY_80,
    fontFamily: 'BentonSansMedium',
    fontSize: '20px',
    lineHeight: '24px'
  },
  responsive: {
    flexDirection: 'column',
    margin: '0 auto'
  }
})

export const mapContainerStyle = {
  width: '100%',
  height: '300px'
}

